// utils/pdf.ts
export function base64ToBlob(base64: string, mime = "application/pdf"): Blob {
  // Acepta con o sin prefijo "data:...;base64,"
  const cleaned = base64.includes(",") ? base64.split(",")[1] : base64;
  const binary = window.atob(cleaned);
  const len = binary.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) bytes[i] = binary.charCodeAt(i);
  return new Blob([bytes], { type: mime });
}

export function blobToObjectURL(blob: Blob): string {
  return URL.createObjectURL(blob);
}

export function downloadBlob(blob: Blob, filename = "documento.pdf") {
  const url = blobToObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}